import { apiRequest } from './api';
import { METADATA } from './endPoints';

export const API_GET_ALL_METADATA = async (page = 0, limit = 10) => {
  const params = {
    page,
    limit,
  };
  return apiRequest('get', METADATA.GET_METADATA, null, params);
};

export const API_GET_METADATA_BY_ID = async (metadataId) => {
  return apiRequest('get', METADATA.GET_METADATA_BY_ID(metadataId), null, null);
};

export const API_POST_METADATA_ = async () => {
  return apiRequest('get', METADATA.CREATE_METADATA, null, null);
};
